import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M19.6001 10.2679C20.9334 11.0377 20.9334 12.9623 19.6001 13.7321L8.3501 20.2272C7.01677 20.997 5.3501 20.0348 5.3501 18.4952L5.3501 5.50481C5.3501 3.96521 7.01677 3.00296 8.3501 3.77276L19.6001 10.2679Z",
            fill: props.color || "#03F5AE"
        })
    }));
};
export default Icon;
